<script lang="ts">
  import Prose from '../lib/components/Prose.svelte';
</script>

<section id="hero" class="hero">
  <Prose>
    <h1>Reliably Incorrect: Measuring where AI agents break</h1>
  </Prose>
</section>

<style>
  .hero {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: var(--space-xl);
  }
</style>
